/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:ec1d4201-16ba-462b-9410-b2e74d98a458",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_ZLOvmc6Z4",
    "aws_user_pools_web_client_id": "6n5o09c035ch1tp70n6ihk8ckv",
    "oauth": {},
    "aws_user_files_s3_bucket": "nuvven-b2b-app0921014c5695490da952f0b646a8cba8app-develop",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
